interface RedirectData {
  studentProjectId: string;
  platformId: string;
  text: string;
  sessionId: string;
  token: string;
  onlyInfo?: boolean;
}

const redirectToChatbotEditor = (redirectData: RedirectData) => {
  const { studentProjectId, platformId, text, sessionId, token, onlyInfo } =
    redirectData;

  const url = new URLSearchParams();
  url.append('token', token);
  url.append('session_id', sessionId);
  url.append('student_project_id', studentProjectId);
  url.append('platform_id', platformId);
  url.append('text', text);
  if (onlyInfo) {
    url.append('only_info', 'true');
  }

  return `https://editor.stemi.education?${url}`;
};

export default redirectToChatbotEditor;
